import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaymentForm from './PaymentForm';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { subscriptionPlans } from '../../../actions/userDashboardAction'
import { useHistory } from 'react-router';
import { MEMBER } from '../../../constants/constants';
const stripePromise = loadStripe('pk_test_51KNnm7AT2o66I7jk3MhGoAIu72HU74DULQS5NxSJupqqNnH5BVkk5xi9Qtq45yMunZyyUtmIdW9EAAHDIyJYlwar00GP45xn5k');

const Payment = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { subscriptionplans } = useSelector(state => state.userDashboardStore)
    const { user } = useSelector(state => state.auth)

    useEffect(() => {
        if (user.userType === MEMBER) history.push('/')
    }, [user, dispatch, history])

    useEffect(() =>{
        dispatch(subscriptionPlans());
    }, [dispatch])

    return (
        <>
            <Elements stripe={stripePromise}>
                <PaymentForm plans={ subscriptionplans }/>
            </Elements>;
        </>
    )
  
};

export default Payment;
